module.exports = __webpack_public_path__ + "cx.58e3aae7aa9703b0db3f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cx.svg
// module chunks = styles